import { Options, Vue } from 'vue-class-component';
import {
  IRoomObjectDTO,
  ThermoAssociatedPump,
  ThermoTypeOfObject,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'FieldsFancoil',
  props: {
    roomObject: {
      type: Object as PropType<IRoomObjectDTO>,
      required: true,
    },
  },
})
export default class FieldsFancoil extends Vue {
  roomObject!: IRoomObjectDTO;

  get typeOptions() {
    return Object.keys(ThermoTypeOfObject)
      .filter((value) => !isNaN(Number(value)))
      .map((value) => Number(value));
  }

  getOptionName(type: ThermoTypeOfObject) {
    return this.$t(`AppResource.${ThermoTypeOfObject[type]}`);
  }

  get associatedPumpOptions() {
    return Object.keys(ThermoAssociatedPump)
      .filter((value) => !isNaN(Number(value)))
      .map((value) => Number(value));
  }

  getAssociatedPumpOptionName(type: ThermoAssociatedPump) {
    return this.$t(`AppResource.${ThermoAssociatedPump[type]}`);
  }
}
